export default __webpack_public_path__ + "static/media/peep-27.26d363d3.svg";